import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AcademicsService } from 'src/app/service/academics.service';
import { ScoresService } from 'src/app/service/scores.service';
import { FileService } from 'src/app/service/file.service';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { DatePipe } from '@angular/common'
@Component({
  selector: 'app-scores-data-create',
  templateUrl: './scores-data-create.component.html',
  styleUrls: ['./scores-data-create.component.scss']
})
export class ScoresDataCreateComponent implements OnInit {
  showLoader: boolean = false;
  creating: boolean = false;
  highlightColors: any = [];
  courses: any = [];
  coursesAssessUnits: any = [];
  yearId: any;
  semesterId: any;
  batchId: any;
  courseId: any;
  examScoreFile: any;
  examScoreFileName: any;
  orgId: any;
  username: any;
  status = 'DRAFT';
  currentExamId: any;

  scoreDataCreateForm = new FormGroup({
    subjectid: new FormControl('', [
      Validators.required,
    ]),
    sbjasesid: new FormControl('', [
      Validators.required,
    ]),
    filename: new FormControl('', [
      Validators.required,
    ]),
    remarks: new FormControl('', [
      // Validators.required,
    ]),
  });

  constructor(
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private academicsService: AcademicsService
    , private roleService: RoleService
    , private orgService: OrgService
    , private datePipe: DatePipe
    , private scoresService: ScoresService
    , private enrollmentGroupService: EnrollmentGroupService
    , private fileService: FileService
  ) {

  }

  ngOnInit(): void {
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.yearId = params['yearId'] || "";
        this.semesterId = params['semesterId'] || "";
        this.batchId = params['batchId'] || "";
        this.courseId = params['courseId'] || "";

        if (this.yearId != "" && this.semesterId != "" && this.batchId != "") {
          if (this.courseId == "") {
            this.courseId = 0;
          }
          this.getBatchCourses(this.batchId);
          // this.getAssUnits();
        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.router.navigate(['/scores-grades/scores-data-upload'], { queryParams: { yearId: this.yearId, semesterId: this.semesterId, batchId: this.batchId ,courseId: this.courseId} });
        }
      });
  }

  scoreDataCreateFormChange() {
    // let classHours = this.createType.controls.classHours.value;
    // let clinicalHours = this.createType.controls.clinicalHours.value;
    // this.createType.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  scoreDataCreateFormSubmit() {
    if (this.scoreDataCreateForm.valid) {
      let fname = this.examScoreFile.name.split('.').slice(0, -1).join('.')
      let fext = this.examScoreFile.name.split('.').pop()
      this.examScoreFileName = fname + "_" + Date.now() + "." + fext;
      let scoreDataObj = this.scoreDataCreateForm.value;
      scoreDataObj.filename = this.examScoreFileName;
      this.addScoreData(scoreDataObj);

    }
    else {
      this.scoreDataCreateForm.markAllAsTouched();
      this.scoreDataCreateForm.markAsDirty();
    }
  }

  addScoreData(scoreDataObj: any) {
    this.creating = true;
    let username = this.globals.currentUserInfo.username;
    scoreDataObj.yearid = this.yearId;
    scoreDataObj.semesterid = this.semesterId;
    scoreDataObj.gradeid = this.batchId;
    scoreDataObj.asesStatus = "DRAFT";

    this.scoresService.addScoreDataUpload(username, this.orgId, scoreDataObj)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
            this.currentExamId = data.id;
            this.handleUploadFiles();
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
          }
          this.creating = false;
        },
        error => {
          this.creating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }

  getBatchCourses(batchId: number) {
    this.showLoader = true;
    this.enrollmentGroupService.getBatchSubjects(this.orgId, batchId)
      .subscribe(
        data => {
          this.courses = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        },
        () => { this.showLoader = false }
      );
  }

  // getCourseAssessUnits() {
  //   this.coursesAssessUnits = [];
  //   let courseId = this.scoreDataCreateForm.controls.subjectid.value;
  //   this.scoresService.getAllAssesmentUnit()
  //     .subscribe(
  //       data => {
  //         this.coursesAssessUnits = data;
  //       },
  //       error => {
  //         this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //       }
  //     );
  // }



  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }

  changeactive() { }

  handleUploadFiles() {
    let formData = new FormData();
    formData.append('file', this.examScoreFile, this.examScoreFileName);

    // console.log("file name : " + this.examScoreFileName);

    // Call API here to upload csv file

    this.scoresService.uploadCSVFile(formData, this.username, this.currentExamId).subscribe(
      data => {
        if (data.sts == "SUCCESS") {
          if (this.globals.lang == "ar") {
            this.toastrService.success(data.arMsg);
          } else {
            this.toastrService.success(data.enMsg);
          }
          this.router.navigate(['/scores-grades/scores-data-upload'], { queryParams: { yearId: this.yearId, semesterId: this.semesterId, batchId: this.batchId, courseId: this.courseId } });
        } else {
          if (this.globals.lang == "ar") {
            this.toastrService.error(data.arMsg);
          } else {
            this.toastrService.error(data.enMsg);
          }
        }
      },
      error => {
        this.toastrService.warning(this.translate.instant("CAN_NOT_UPLOAD_FILES"));
      }
    );
  }

  changeFile(event: any) {
    let typesAccept = ['application/vnd.ms-excel', 'text/csv'];
    // Max size 200 MEGA
    let maxSize = 209715200;
    if (event.target.files.length > 0) {
      var currentFile = event.target.files[0];
      console.log("file type: " + currentFile.type);
      if ((typesAccept.includes(currentFile.type)) && currentFile.size <= maxSize) {
        this.examScoreFile = event.target.files[0];
        return true;
      } else {
        this.scoreDataCreateForm.controls.filename.reset();
        this.scoreDataCreateForm.controls.filename.markAsDirty();
        this.scoreDataCreateForm.controls.filename.markAsTouched();

        if (currentFile.size > maxSize) {
          this.toastrService.error(this.translate.instant("MAX_FILE_SIZE_200_MB"))
        }
        return false;
      }
    } else {
      return false;
    }
  }


  getAssUnits() {
    this.coursesAssessUnits = [];
    let courseId = this.scoreDataCreateForm.controls.subjectid.value;
    let type = "ONGOING";
    this.scoresService.getAssUnitsByType(type, this.orgId, this.yearId, this.semesterId, this.batchId, courseId)
      .subscribe(
        data => {
          if (data) {
            this.coursesAssessUnits = data;
          }
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );

  }
}


